import { render, staticRenderFns } from "./OtoTag.vue?vue&type=template&id=6f6d64fc"
import script from "./OtoTag.vue?vue&type=script&lang=js"
export * from "./OtoTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports